import React from 'react';
import { ICON } from 'resources/constants';
import { UserQuizScore } from 'common/types';

import {
  Wrapper,
  KnowledgeWrapper,
  KnowledgeIcon,
  Title,
  Text,
  QuestionsWrapper,
  QuestionWrapper,
  QuestionIcon,
  SmallText,
  Icon,
} from './elements';

type Props = {
  readonly className?: string;
  readonly title: string;
  readonly text?: string;
  readonly onClick: () => void;
  readonly colors: {
    primary: string;
    secondary: string;
    tertiary: string;
    quaternary: string;
    quinary: string;
  };
  readonly quizScore?: UserQuizScore;
  readonly reviewText: string;
};

function QuizCard({
  className,
  title,
  text,
  onClick,
  colors,
  quizScore,
  reviewText,
}: Props): React.ReactElement {
  return (
    <Wrapper onClick={onClick} className={className} color={colors.tertiary}>
      <KnowledgeWrapper
        color={quizScore.isCompleted ? '#FBC02D' : colors.quaternary}
      >
        <KnowledgeIcon color={'#fff'} icon={ICON.school} />
      </KnowledgeWrapper>
      <Title>{title}</Title>
      {quizScore.isStarted ? (
        <QuestionsWrapper>
          {quizScore.questions.map(question => (
            <QuestionWrapper
              key={question.question}
              borderColor={
                question.isAnswered ? '#fff' : 'rgba(255, 255, 255, 0.5)'
              }
            >
              {question.isAnswered && (
                <QuestionIcon
                  color={'#fff'}
                  icon={question.isCorrect ? ICON.checkCircle : ICON.cancel}
                />
              )}
            </QuestionWrapper>
          ))}
          {quizScore.isCompleted && <SmallText>{reviewText}</SmallText>}
        </QuestionsWrapper>
      ) : (
        <Text>{text}</Text>
      )}
      <Icon color={'#fff'} icon={ICON.keyboardArrowRight} />
    </Wrapper>
  );
}

export default QuizCard;
